import { Form, Input, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import ticketTypeService from '../../../../services/config/ticket_type.service';
import parkService from '../../../../services/config/park.service';

const EditTicketTypeModal = ({ form, ticket_type_id, modal, }) => {
    const [state, setState] = useState({
        loading : false,
        ticket_type : null,
        parks : [],
    });
    const has_multi_park = Form.useWatch('has_multi_park', form);

    const fetchTicketType = async () => {
        setState(state => ({...state, loading : true, }));
        const [ticketTypeResponse, parkResponse] = await Promise.all([
            ticketTypeService?.fetchTicketType({ ticket_type_id : ticket_type_id }),
            parkService?.getPark(),
        ]);

        const { ticket_types } = ticketTypeResponse;
        const ticket_type = ticket_types?.[0];

        form.setFieldsValue({
            name : ticket_type?.name,
            has_multi_park : ticket_type?.has_multi_park,
            park_ids : ticket_type?.ticket_type_parks?.map(ttp => ttp?.park_id),
        });
        setState(state => ({...state, loading : false, ticket_type : ticket_type, parks : parkResponse?.parks ?? [], }));
    }

    useEffect(() => {
        fetchTicketType();
    }, [ticket_type_id, modal])

    return (
        <>
            <Form.Item label={'Name'} name={'name'}>
                <Input />
            </Form.Item>
            <Form.Item label={'Multi Park'} name={'has_multi_park'} valuePropName='checked'>
                <Switch />
            </Form.Item>
            {has_multi_park && (
                <Form.Item label={'Parks'} name={'park_ids'}>
                    <Select
                    mode='multiple'
                    placeholder='Select parks'
                    options={state?.parks?.map(park => ({ label: park?.name, value: park?.park_id }))}
                    />
                </Form.Item>
            )}
        </>
    );
}

export default EditTicketTypeModal;